import { Document } from '@/models/document'
import { DocumentAPI } from '@/api/document.api'
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface'
import { Viproc } from '@/models/viproc'
import { DocumentoAPI } from '@/api/documento.api'
import Documento from '@/models/documento'


const documentoAPI = new DocumentoAPI()

const getAll =  (): AxiosObservable<Documento[]> =>{
  return documentoAPI.getAll();
}
export default { getAll }
